/**
 * BattleData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { BattleInfo } from './battle_info'

/**
 * BattleData
 */
export interface BattleData {
  /** 对线群ID */
  id?: string
  /** 对线群基础信息 */
  info?: BattleInfo
}

/**
 * BattleData Schema
 */
export const BattleDataSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '对线群ID',
      format: 'string',
      type: 'string',
      label: '对线群ID',
    },
    info: {
      $ref: 'BattleInfo',
      description: '对线群基础信息',
      label: '对线群基础信息',
    },
  },
  type: 'object',
}
